import Axios from "axios";
import React, { Component } from "react";
import Slider from "react-slick";
import larrow from '../assets/larrow.png'
import rarrow from '../assets/rarrow.png'
import { BASE } from '../api/api'
import HtmlParser from "react-html-parser";
import { Link } from "react-router-dom";


class AllTopics extends Component {
    constructor(props) {
        super(props)
        this.state = {
            topics: null,
            topicInclude: []
        }
    }
    componentDidMount() {
        Axios.get(`${BASE}jsonapi/taxonomy_term/topic?include=field_topic_thumbnail`)
            .then(data => {
                console.log("topics", data.data.data)
                this.setState({
                    topics: data.data.data,
                    topicInclude: data.data.included
                })
            })
            .catch(err => {
                console.log("topics error", err)
            })
    }
    render() {
        const settings = {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            infinite: false,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />
        };
        const settingsmob = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: false,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />
        };
        const api = [
            { author: "Dr. Joseph Lumbard’s Podcast", name: "Quran for all seasons", link: "https://pod.co/quran-for-all-seasons" },
            { author: "Dr. Logan Cochrane’s Podcast", name: "Progress | مستدام", link: "https://soundcloud.com/hbkuprogresspodcast" },
        ]
        function SampleNextArrow(props) {
            const { className, style, onClick } = props;
            return (
                <img
                    src={rarrow}
                    className={className}
                    style={{ ...style, position: 'absolute', right: "-1%" }}
                    onClick={onClick}
                />
            );
        }

        function SamplePrevArrow(props) {
            const { className, style, onClick } = props;
            return (
                <img
                    src={larrow}
                    className={className}
                    style={{ ...style, position: 'absolute', left: "-1%", zIndex: "9" }}
                    onClick={onClick}
                />
            );
        }
        return (
            <div className='dark-blue-back'>
                <div className='container all-topic topics'>
                    {/* <div className='all-topic-heading'>All Topics</div> */}
                    <div className="mob-only">
                        <Slider {...settingsmob} >
                            {api ? api.map((item, ind) => {
                                return (
                                    <div className='topic-carousel' style={{ paddingRight: "2%" }}>
                                        <div className='all-topic-heading'>{item.author}</div>
                                        <div className='latest-image-container'>
                                            <a href={`${item.link}`} target="_blank">
                                                <img className='topic-img' src={"/cluster/c1.png"} />
                                            </a>
                                        </div>
                                        <a href={`${item.link}`} target="_blank" onClick={() => window.scrollTo(0, 0)} className='title'>{item.name ? item.name : ""}</a>
                                    </div>
                                )
                            }) : ""}
                        </Slider>
                    </div>
                    <div className="desk-only">
                        <Slider {...settings} >
                            {api ? api.map((item, ind) => {
                                return (
                                    <div className='topic-carousel' style={{ paddingRight: "2%" }}>
                                        <div className='all-topic-heading'>{item.author}</div>
                                        <div className='latest-image-container'>
                                            <a href={`${item.link}`} target="_blank">
                                                <img className='topic-img' src={"/cluster/c1.png"} />
                                            </a>
                                        </div>
                                        <a href={`${item.link}`} target="_blank" onClick={() => window.scrollTo(0, 0)} className='title'>{item.name ? item.name : ""}</a>
                                    </div>
                                )
                            }) : ""}
                        </Slider>
                    </div>
                </div>
            </div>
        )
    }
} export default AllTopics;